import { createStore, compose, type Store } from "redux"
import { reducer, initialState, type State } from "./reducers"
import env from "@/common/env"

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
  }
}

let configureStore: (state: Partial<State>) => Store

if (env.PRODUCTION) {
  configureStore = preloadedState => {
    const store = createStore(reducer, { ...initialState, ...preloadedState })

    return store
  }
} else {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  configureStore = preloadedState => {
    const store = createStore(reducer, { ...initialState, ...preloadedState }, composeEnhancers())

    return store
  }
}

export default configureStore
